<template>
  <v-dialog fullscreen v-model="visible">
    <div>
      <box title="نقشه">
        <div slot="top-action-view">
          <v-btn dark icon @click="visible = false">
            <v-icon>mdi-close</v-icon></v-btn
          >
        </div>
        <div class="pa-3">
          <v-row class="h-100" style="height: 91vh">
            <v-col>
              <l-map
                :options="mapOptions"
                style="z-index: 0"
                :zoom="zoom"
                :center="center"
                @update:center="centerUpdate"
              >
                <l-tile-layer
                  :url="url"
                  :attribution="attribution"
                ></l-tile-layer>
                <l-control-attribution
                  :position="'bottomright'"
                  :prefix="'www.elmosanat.com'"
                />

                <div>
                  <div v-if="location">
                    <l-marker :lat-lng="getMarkerLatLng(location)"></l-marker>
                  </div>
                </div>
              </l-map>
            </v-col>
          </v-row>
        </div>
      </box>
    </div>
  </v-dialog>
</template>

<script>
// If you need to reference 'L', such as in 'L.icon', then be sure to
// explicitly import 'leaflet' into your component
import L from "leaflet";
import { LMap, LTileLayer, LMarker, LControlAttribution } from "vue2-leaflet";

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LControlAttribution,
  },
  data() {
    return {
      visible: false,
      location: {},
      zoom: 12,
      center: L.latLng(35.687656, 51.388546),
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      attribution: "",
      mapOptions: {
        zoomControl: true,
        attributionControl: false,
        zoomSnap: true,
      },
      centerMarker: "",
    };
  },
  mounted() {
    this.centerMarker = this.center;
  },
  methods: {
    show(location) {
      console.log(location);
      this.visible = true;
      this.location = location;
      this.center = L.latLng(location.Latitude, location.Longtitude);
    },
    latLng(lat, lng) {
      return L.latLng(lat, lng);
    },
    centerUpdate(center) {
      this.center = center;
    },
    getMarkerLatLng(marker) {
      return L.latLng(marker.Latitude, marker.Longtitude);
    },
  },
};
</script>

<style>
.new-marker {
  color: #569dd6;
  
}
</style>